// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".link[data-v-0aa16058]{cursor:pointer;-webkit-text-decoration:underline;text-decoration:underline}.map[data-v-0aa16058]{height:300px;overflow:hidden;position:relative;width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
